import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Employee } from '../../../types';
import Input from '../../Form/Input';
import Select from '../../Form/Select';

interface EmployeeEmploymentDetailsProps {
  register: UseFormRegister<Employee>;
  errors: FieldErrors<Employee>;
  userRole: string;
  branchOptions: { value: string; label: string }[];
  payType?: string;
}

const EmployeeEmploymentDetails: React.FC<EmployeeEmploymentDetailsProps> = ({
  register,
  errors,
  userRole,
  branchOptions,
  payType = 'monthly'
}) => {
  return (
    <>
      <div className="col-span-full">
        <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2 mt-6">
          Contact Information
        </h3>
      </div>
      
      <Input
        label="Mobile Number (رقم الموبايل)"
        {...register('phoneNumber')}
        error={errors.phoneNumber?.message}
        placeholder="+1234567890"
      />
      
      <Input
        label="Email"
        type="email"
        {...register('email')}
        error={errors.email?.message}
        placeholder="john@example.com"
      />

      <div className="col-span-full">
        <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2 mt-6">
          Documents & Certificates
        </h3>
      </div>
      
      <Input
        label="Seaman's Book Number (رقم الجواز البحري)"
        {...register('seamanBookNumber')}
        error={errors.seamanBookNumber?.message}
        placeholder="SB123456"
      />
      
      <Input
        label="Seaman's Book Issue Date (تاريخ إصدار الجواز البحري)"
        type="date"
        {...register('seamanBookIssueDate')}
        error={errors.seamanBookIssueDate?.message}
      />
      
      <Input
        label="Seaman's Book Expiry (تاريخ انتهاء الجواز البحري)"
        type="date"
        {...register('seamanBookExpiry')}
        error={errors.seamanBookExpiry?.message}
      />

      <div className="col-span-full">
        <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2 mt-6">
          Employment Details
        </h3>
      </div>
      
      <Input
        label="Hire Date"
        type="date"
        {...register('hireDate')}
        error={errors.hireDate?.message}
      />
      
      <Select
        label="Vessel/Headquarters"
        {...register('branchId')}
        options={branchOptions}
        error={errors.branchId?.message}
      />
      
      <Select
        label="Pay Type (نظام الأجر)"
        {...register('payType')}
        options={[
          { value: 'monthly', label: 'Salary per month (مرتب شهري)' },
          { value: 'daily', label: 'Rate per day (أجر يومي)' }
        ]}
        error={errors.payType?.message}
      />

      {userRole !== 'hr' && payType !== 'daily' && (
        <Input
          label="Salary (per month)"
          type="number"
          {...register('salary')}
          error={errors.salary?.message}
          placeholder="50000"
        />
      )}

      {userRole !== 'hr' && payType === 'daily' && (
        <Input
          label="Rate per Day (الأجر اليومي)"
          type="number"
          step="0.01"
          {...register('dailyRate')}
          error={errors.dailyRate?.message}
          placeholder="500"
        />
      )}
      
      <Input
        label="Amount (Allowance/Bonus)"
        type="number"
        {...register('amount')}
        error={errors.amount?.message}
        placeholder="10000"
      />
      
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          {...register('travelPermit')}
          className="h-4 w-4 text-ocean-600 focus:ring-ocean-500 border-gray-300 rounded"
        />
        <label className="text-sm font-medium text-gray-700">
          Travel Permit (تصريح السفر)
        </label>
      </div>
      
      <Select
        label="Status"
        {...register('status')}
        options={[
          { value: 'active', label: 'Active' },
          { value: 'inactive', label: 'Inactive' }
        ]}
      />
    </>
  );
};

export default EmployeeEmploymentDetails;
